import React from 'react';

const Marquee = ({ items, className = '' }) => {
  const content = items.join('   ✺   ');

  return (
    <div className={`marquee ${className}`}>
      <div className="marquee-track">
        <span>{content}</span>
        <span aria-hidden="true">{content}</span>
      </div>
    </div>
  );
};

export default Marquee;
